import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  callMeRequest: ['infos', 'day'],
  callMeSuccess: ['result'],
  callMeFailed: ['error'],
});

const INITIAL_STATE = Immutable({
  isLoading: false,
  error: {},
});

export const callMeRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });

export const callMeSuccess = (state = INITIAL_STATE, { result }) => state.merge({ isLoading: false, result });

export const callMeFailed = (state = INITIAL_STATE, { error }) => state.merge({ isLoading: false, error });

export default createReducer(INITIAL_STATE, {
  [Types.CALL_ME_REQUEST]: callMeRequest,
  [Types.CALL_ME_SUCCESS]: callMeSuccess,
  [Types.CALL_ME_FAILED]: callMeFailed,
});
